<div class="application-nav-container">
  <div class="application-nav-container__button application-nav-container__button--prev">
    <button
      *ngIf="!isFirstSection"
      class="button button--secondary button--yellow"
      (click)="previousSection()"
      role="button"
    >
      Back
    </button>
  </div>
  <div
    *ngIf="!isLastSection"
    class="application-nav-container__button application-nav-container__button--next"
    [ngClass]="{ 'application-nav-container__button--next-left': isFirstSection }"
  >
    <button
      *ngIf="showNextButton()"
      class="button button--primary button--yellow"
      [ngClass]="{ 'button--disabled': disableNextButton() }"
      (click)="nextSection()"
      role="button"
      [disabled]="disableNextButton()"
    >
      Next
    </button>
    <button
      *ngIf="showValidateButton()"
      class="button button--primary button--yellow button--disabled"
      role="button"
      [disabled]="true"
    >
      Validating ...
    </button>
  </div>
  <div
    *ngIf="isLastSection && (!appState.isAdvisor || appState.isTeleInterviewerLoggedIn)"
    class="application-nav-container__button application-nav-container__button--next"
    [ngClass]="{
      'application-nav-container__button--next-left': isFirstSection,
      'button--disabled': !isSubmitEnabled()
    }"
  >
    <button
      *ngIf="!appState.isTeleInterviewerLoggedIn"
      class="button button--primary button--yellow"
      (click)="submitFromNavigation()"
      [disabled]="!isSubmitEnabled()"
      role="button"
    >
      Submit Application
    </button>
    <button
      *ngIf="appState.isTeleInterviewerLoggedIn"
      class="button button--primary button--yellow"
      [disabled]="!isTeleSubmitEnabled()"
      (click)="teleInterviewerSubmitFromNavigation()"
      role="button"
    >
      Ready to Submit
    </button>
  </div>
  <div class="application-nav-container__alert" *ngIf="isLastSection && submitPolicyError">
    <alert id="policy-number-warning" [isOpen]="submitPolicyError" [intent]="alertIntent.DANGER" class="">
      Something went wrong. Please refresh the page and try again.
    </alert>
  </div>
</div>
